import Experience from "../Experience";
import * as THREE from "three"


export default class CandyHouse
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug

        this.resource = this.resources.items.candyHouse
        

        this.setModel()
        this.setDebug()
    }

    setModel(){
        this.model = this.resource.scene
        this.model.position.set(8, 0.2, -10)
        this.scene.add(this.model)

        this.model.traverse((child) =>
        {
            if(child instanceof THREE.Mesh){
                child.castShadow = true
            }
        })

        this.houseLight = new THREE.PointLight('#FB4141', 20, 0, 4)
        this.scene.add(this.houseLight)
        this.houseLight.position.set(8, 3, -8.2)

    }

    setDebug()
    {
        if(this.debug.active)
        {
            this.debugHouseLight = this.debug.degugLight.addFolder('debugHouseLight')

            this.debugHouseLight.add(this.houseLight.position, 'x').min(0).max(20).step(0.0001)
            this.debugHouseLight.add(this.houseLight.position, 'y').min(-10).max(20).step(0.0001)
            this.debugHouseLight.add(this.houseLight.position, 'z').min(-10).max(20).step(0.0001)
        }
    }
}